import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMultiScoreSuggestionType,
  BackendMutationScoreSavedVariationTextArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ScoreSavedVariationText(
    $savedVariationId: ID!
    $text: String!
    $scoringMethod: ScoringMethodInput
  ) {
    scoreSavedVariationText(
      savedVariationId: $savedVariationId
      text: $text
      scoringMethod: $scoringMethod
    ) {
      score
    }
  }
`;

// Shares the `{ variationId, text, scoringMethod }` call shape with scoreVariationText
// (callers pick one via a shared reference), so the BE `savedVariationId` arg is mapped here.
type Variables = Omit<BackendMutationScoreSavedVariationTextArgs, 'savedVariationId'> & {
  variationId: ID;
};
type Result = Pick<BackendMultiScoreSuggestionType, 'score'>;

export const scoreSavedVariationText = async (
  { variationId, text, scoringMethod }: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { savedVariationId: variationId, text, scoringMethod },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
